import React from "react";
import Modal from "./Modal";
import Sidebar from "./Sidebar";
import Home from "./Home";

function App() {
  return (
    <>
      <Home></Home>
      <Modal></Modal>
      <Sidebar></Sidebar>
    </>
  );
}

export default App;
